import { createSlice, PayloadAction, createSelector } from '@reduxjs/toolkit'
import { ApiMiddlewarePayload } from '@ocean/api'
import { ApiAction, createApiAction } from 'api'
import { EnvironmentUtils } from 'utils'
import { userLoggedOut } from 'core/session/slices/session'
import { getHomeOverview } from 'modules/Home/api/homeService'
import { getListSimulatorTrainings } from 'modules/simulatorTrainings/instructor/instructorLed/SimulatorList/api/simulatorListService'
import { ApiSimulatorListResponse } from 'modules/simulatorTrainings/instructor/instructorLed/SimulatorList/slices/simulatorList/types'
import { SimulatorTraining } from 'modules/simulatorTrainings/instructor/instructorLed/SimulatorList/types'
import { HomeOverviewState, ApiHomeOverviewResponse } from './types'

const initialState: HomeOverviewState = {
  homeOverviewData: {},
  simulatorTrainingListData: {},
}

const homeSlice = createSlice({
  name: 'home',
  initialState,
  reducers: {
    homeOverviewLoaded(
      state,
      action: PayloadAction<ApiMiddlewarePayload<ApiHomeOverviewResponse>>
    ) {
      state.homeOverviewData = action.payload
    },
    listSimulatorTrainingsLoaded(
      state,
      action: PayloadAction<ApiMiddlewarePayload<ApiSimulatorListResponse>>
    ) {
      state.simulatorTrainingListData = action.payload
    },
  },
  extraReducers: builder => {
    builder.addCase(userLoggedOut, () => {
      return initialState
    })
  },
})

const { homeOverviewLoaded, listSimulatorTrainingsLoaded } = homeSlice.actions

export default homeSlice.reducer

export const getHomeOverviewData = () => {
  return createApiAction({
    apiCalls: {
      homeOverview: getHomeOverview,
    },
    payloadAction: homeOverviewLoaded,
    shouldCallApi: ({ home }) => !home.homeOverviewData.isLoading,
  })
}

export const getSimulatorTypes = createSelector(
  (simulatorTrainings: SimulatorTraining[] = []) => simulatorTrainings,
  simulatorTrainings =>
    simulatorTrainings.reduce((types, training) => {
      const { id, type } = training
      types[id] = type
      return types
    }, {} as Record<string, number>)
)

export const loadListSimulatorTrainingsData = (): ApiAction => {
  return createApiAction({
    apiCalls: {
      list: getListSimulatorTrainings,
    },
    payloadAction: listSimulatorTrainingsLoaded,
    shouldCallApi: () =>
      EnvironmentUtils.getPermissions('general').isSimulatorTrainingInstructorLedEnabled,
  })
}
